module.exports = __webpack_public_path__ + "static/media/nicolas_tagliafico.d9a0e096.jpg";